var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.253 1.126 24.9 6.75a.563.563 0 0 1-.067.963l-11.33 6.265 2.792-12.53a.61.61 0 0 1 .958-.322zm7.884 21.283L13.95 16 25.137 9.59a.586.586 0 0 1 .895.506V21.9a.59.59 0 0 1-.895.51zm-7.893 8.461 7.656-5.624a.573.573 0 0 0-.062-.975l-11.335-6.264 2.792 12.53a.605.605 0 0 0 .949.344v-.009zM13.95 2.165l-2.909 13.604 2.874 13.613a.577.577 0 0 1-.895.588L5.603 24.27A1.545 1.545 0 0 1 5 23.023V8.523a1.544 1.544 0 0 1 .604-1.23l7.451-5.715a.577.577 0 0 1 .895.586z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnc);
export default __webpack_public_path__ + "static/media/KNC.e71732a0a0806a92821507167efe739a.svg";
export { ForwardRef as ReactComponent };